import React from "react";
import { FaXTwitter } from "react-icons/fa6";
const Footer = () => {
  return (
    <footer className="mt-5">
      {/* Top Light Section */}
      <div className="bg-light border-top">
        <div className="container py-5">
          <div className="row gy-4">
            {/* Brand / About */}
            <div className="col-12 col-lg-4">
              <a
                href="/"
                className="d-flex align-items-center gap-2 fw-bold mb-3 text-decoration-none"
              >
                <img
                  src="/assets/img/ab_book_logo.png"
                  alt="AssistBook"
                  style={{ height: "42px" }}
                />
              </a>
              <p className="text-muted small mb-3">
                Assist Buddi Books is a smart & business management platform
                designed to help businesses grow faster and stay compliant.
              </p>
            </div>

            {/* Business Links */}
            <div className="col-6 col-md-3 col-lg-2">
              <h6 className="fw-semibold mb-3" style={{ color: " #0b2b6d" }}>
                Quick Links
              </h6>
              <ul className="list-unstyled small text-muted">
                <li className="mb-2 ">
                  {/* <a
                    href="/features#inventory"
                    className="text-muted"
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.color = "#0b2b6d")
                    }
                    onMouseLeave={(e) => (e.currentTarget.style.color = "")}
                  >
                    Manage Inventory
                  </a> */}
                  <a
                    href="/features#inventory"
                    className="text-muted"
                    style={{ textDecoration: "none" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.setProperty(
                        "color",
                        "#0b2b6d",
                        "important",
                      );
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.removeProperty("color");
                    }}
                  >
                    Manage Inventory
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/features#services"
                    className="text-muted"
                    style={{ textDecoration: "none" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.setProperty(
                        "color",
                        "#0b2b6d",
                        "important",
                      );
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.removeProperty("color");
                    }}
                  >
                    Manage Services
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/features#expense"
                    className="text-muted"
                    style={{ textDecoration: "none" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.setProperty(
                        "color",
                        "#0b2b6d",
                        "important",
                      );
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.removeProperty("color");
                    }}
                  >
                    Track Expenses
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/features#transactions"
                    className="text-muted"
                    style={{ textDecoration: "none" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.setProperty(
                        "color",
                        "#0b2b6d",
                        "important",
                      );
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.removeProperty("color");
                    }}
                  >
                    Ledger & Transactions
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/features#reports"
                    className="text-muted"
                    style={{ textDecoration: "none" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.setProperty(
                        "color",
                        "#0b2b6d",
                        "important",
                      );
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.removeProperty("color");
                    }}
                  >
                    Business Reports
                  </a>
                </li>
              </ul>
            </div>

            {/* Product Links */}
            <div className="col-6 col-md-3 col-lg-2">
              <h6 className="fw-semibold mb-3" style={{ color: " #0b2b6d" }}>
                Platform
              </h6>
              <ul className="list-unstyled small">
                <li className="mb-2">
                  <a
                    href="/features"
                    className="text-muted text-decoration-none"
                    style={{ textDecoration: "none" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.setProperty(
                        "color",
                        "#0b2b6d",
                        "important",
                      );
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.removeProperty("color");
                    }}
                  >
                    Features
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/pricing"
                    className="text-muted text-decoration-none"
                    style={{ textDecoration: "none" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.setProperty(
                        "color",
                        "#0b2b6d",
                        "important",
                      );
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.removeProperty("color");
                    }}
                  >
                    Pricing
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/partner"
                    className="text-muted text-decoration-none"
                    style={{ textDecoration: "none" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.setProperty(
                        "color",
                        "#0b2b6d",
                        "important",
                      );
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.removeProperty("color");
                    }}
                  >
                    Partner
                  </a>
                </li>
                {/* <li className="mb-2">
                  <a href="/#gst" className="text-muted text-decoration-none">
                    GST & E-Invoice
                  </a>
                </li> */}
              </ul>
            </div>

            {/* Connect With Us */}
            <div className="col-12 col-lg-4 text-lg-start">
              <h5 className="mb-2 fw-bold" style={{ color: " #0b2b6d" }}>
                Connect With Us
              </h5>
              <p className="small opacity-75 mb-3">
                Follow us on social media for updates and insights
              </p>
              <div
                className="d-flex gap-3 justify-content-lg-start"
                style={{ color: " #0b2b6d" }}
              >
                <a
                  className="fs-5"
                  target="blank"
                  href="https://www.facebook.com/assistbuddi"
                >
                  <i className="bi bi-facebook"></i>
                </a>
                <a
                  className="fs-5"
                  target="blank"
                  href="https://x.com/AssistBuddi"
                >
                  {/* <i className="bi bi-twitter-x"></i> */}
                  <FaXTwitter />
                </a>

                {/* <a
                  className="fs-5"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://x.com/AssistBuddi"
                  aria-label="Follow us on X"
                >
                  <i className="bi bi-twitter-x"></i>
                </a> */}
                <a
                  className="fs-5"
                  target="blank"
                  href="https://www.linkedin.com/company/assistbuddi/"
                >
                  <i className="bi bi-linkedin"></i>
                </a>
                <a
                  className="fs-5"
                  target="blank"
                  href="https://www.instagram.com/assistbuddi_books/"
                >
                  <i className="bi bi-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Dark Section */}
      <div className="text-dark">
        {/* Bottom Copyright */}
        <div
          className="text-center py-3 border-secondary opacity-75"
          style={{ fontSize: "12px" }}
        >
          © 2026 FOXAISR TECHNOLOGY PVT LTD | All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
